export const services = {
  refresh: 'services-refreshed',
  filters: 'service-filters-received',
  list: 'services-full-list-received',
  table: 'service-list-for-table-received',
  partner: 'partner-services-received',
  short: 'services-short-list-received',
  names: 'list-of-service-names-received',
  get: 'service-data-received',
  search: 'service-search-result-received',
  'partial-search': 'service-search-result-received',
  put: 'service-data-updated',
  patch: 'service-details-updated',
  'patch-group': 'group-of-services-updated',
  'group-search': 'group-search-result-received',
  post: 'new-service-created',
  delete: 'service-deleted'
}

export const sla = {
  list: 'sla-list-received',
  get: 'sla-content-received',
  put: 'sla-data-updated',
  update: 'sla-data-updated',
  create: 'new-sla-created',
  post: 'new-sla-created',
  upload: 'sla-file-uploaded',
  remove: 'sla-removed',
  read: 'local-file-content-loaded'
}
